import React, { useCallback, useState, useEffect } from 'react';
import {
  FiSun,
  FiCoffee,
  FiMoon,
} from 'react-icons/fi';
import {
  getHours, addHours, differenceInCalendarDays,
} from 'date-fns';
import { toDate } from 'date-fns-tz';
import { ProcessHeader } from '../../../components';

function useDeliveryShift(commands) {
  const [notAllowedShifts, updateNotAllowedShifts] = useState([]);

  const setDeliveryShift = (shift) => {
    commands.order.changeDataAttribute('deliveryShift', shift);
    commands.process.goToStep(5);
  }

  const setNotAllowedShifts = useCallback((deliveryDate, availableShifts, offers) => {
    const producerTimezone = 'Brasil/Brasilia';
    const currentDateInProducerTimezone = toDate(new Date(), { timeZone: producerTimezone });

    const biggestLeadTimeInHours = Math.max(...offers.map((offer) => {
      if (offer.type !== 'scheduled_delivery') return 0;

      const { leadTime } = offer;
      const leadTimeScaleTag = leadTime[leadTime.length - 1];

      return {
        d: Number(leadTime.replace('d', '')) * 24,
        h: Number(leadTime.replace('h', '')),
      }[leadTimeScaleTag];
    }));

    const leadTimeDateEnd = addHours(currentDateInProducerTimezone, biggestLeadTimeInHours);
    const leadTimeDateEndHour = getHours(leadTimeDateEnd);

    updateNotAllowedShifts(differenceInCalendarDays(leadTimeDateEnd, deliveryDate) === 0
      ? availableShifts.filter((shift) => ({
        morning: leadTimeDateEndHour >= 12,
        afternoon: leadTimeDateEndHour >= 18,
        night: leadTimeDateEndHour >= 22,
      }[shift]))
      : []);
  }, []);

  const goBack = () => commands.process.previousStep();

  return ({
    localStates: {
      notAllowedShifts,
    },
    eventHandlers: {
      goBack,
      setDeliveryShift,
      setNotAllowedShifts,
    },
  });
}

export default function DeliveryShift(props) {
  const { commands, sharedStates } = props;
  const { eventHandlers, localStates } = useDeliveryShift(commands);

  useEffect(() => eventHandlers.setNotAllowedShifts(sharedStates.order.deliveryDate, sharedStates.availableShifts, sharedStates.offers), []);

  return (
    <section className="step-container">
      <ProcessHeader goBackAction={eventHandlers.goBack} />
      <h1 className="step-title">
        {`Em qual período do dia deseja ${sharedStates.order.deliveryMethod === 'home_delivery' ? 'receber' : 'retirar'} seu produto?`}
      </h1>

      <div className="step-options-group">
        {
          sharedStates?.availableShifts?.includes('morning') && !localStates?.notAllowedShifts?.includes('morning') && (
            <button
              type="button"
              onClick={() => eventHandlers.setDeliveryShift('morning')}
              className={`step-option-button ${sharedStates.order.deliveryShift === 'morning' ? 'step-option-selected' : ''}`}
            >
              <div className="step-option-icon">
                <FiCoffee size={32} strokeWidth="0.8" />
              </div>

              <div className="step-option-text">
                <h2>Manhã</h2>
                <p>De 08:00 às 12:00</p>
              </div>
            </button>
          )
        }
        {
          sharedStates?.availableShifts?.includes('afternoon') && !localStates?.notAllowedShifts?.includes('afternoon') && (
            <button
              type="button"
              onClick={() => eventHandlers.setDeliveryShift('afternoon')}
              className={`step-option-button ${sharedStates.order.deliveryShift === 'afternoon' ? 'step-option-selected' : ''}`}
            >
              <div className="step-option-icon">
                <FiSun size={32} strokeWidth="0.8" />
              </div>

              <div className="step-option-text">
                <h2>Tarde</h2>
                <p>De 12:00 às 18:00</p>
              </div>
            </button>
          )
        }
        {
          sharedStates?.availableShifts?.includes('night') && !localStates?.notAllowedShifts?.includes('night') && (
            <button
              type="button"
              onClick={() => eventHandlers.setDeliveryShift('night')}
              className={`step-option-button ${sharedStates.order.deliveryShift === 'night' ? 'step-option-selected' : ''}`}
            >
              <div className="step-option-icon">
                <FiMoon size={32} strokeWidth="0.8" />
              </div>

              <div className="step-option-text">
                <h2>Noite</h2>
                <p>De 18:00 às 22:00</p>
              </div>
            </button>
          )
        }
      </div>
    </section>
  );
}
